<breadcrumb endText="Announcements" [navigations]="breadcrumbNavs" />
<div class="m-5">
  <div class="flex justify-between">
    <div class="font-medium text-xl mb-2">
      Announcements
    </div>
    <clear-button [faIcon]="faPlus" (click)="addAnnouncement()" text="Add Announcement" />
  </div>
  <hr class="my-3" />
  <div class="mt-3 grid grid-cols-6 font-bold text-center">
    <div>
      Message
    </div>
    <div>
      Dashboard
    </div>
    <div>
      Start Date
    </div>
    <div>
      End Date
    </div>
    <div>
      Active?
    </div>
    <div>
      Action
    </div>
  </div>
  @for (message of messages; track message; let i = $index) {
    <div [ngClass]="i % 2 === 0? 'text-center mt-3 grid grid-cols-6 p-2 rounded-[8px]': 'text-center mt-3 grid grid-cols-6 p-2 rounded-[8px] bg-gray-100'">
      <div>
        {{message.msg}}
      </div>
      <div>
        {{message.dashboard}}
      </div>
      <div>
        {{message.start | date: 'short'}}
      </div>
      <div>
        {{message.end | date: 'short'}}
      </div>
      <div>
        {{message.active}}
      </div>
      <div class="flex justify-center">
        <dropdown-menu [menuItems]="message.menuItem" aria-label="Announcement Menu" />
      </div>
    </div>
  }
</div>
